// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


// The lactation of an animal.
// Example: 1

export const lactationMinimum = 0.0; // inclusive
export const lactationMaximum = 99.0; // inclusive

export const LactationSchema = t.refinement(t.Integer, x => x >= lactationMinimum && x <= lactationMaximum, 'Lactation');

export type Lactation = t.TypeOf<typeof LactationSchema>;
